import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GET } from "../../utils/Method";
import { RIBBIONS_TRANSACTIONS_LIST } from "../../utils/url";
import { RootState } from "../store";
const apiEnpoint = process.env.REACT_APP_RIBBIONS_API_BASE_URL;

export interface RibbonsTransactionState {
  apiState: "idle" | "fetching" | "failed";
  Response: any;
}

const initialState: RibbonsTransactionState = {
  apiState: "idle",
  Response: []
};

export const getInitialRibbonsTransactionState = createAsyncThunk(
  "RibbonsTransaction/RibbonsTransactionData",
  async ({ accessToken = "", userId = null }: any, thunkAPI) => {
    try {
      let headers = {
        Authorization: `bearer ${accessToken}`,
        "Content-Type": "application/json"
      };

      const result: any = await GET({
        url: apiEnpoint + RIBBIONS_TRANSACTIONS_LIST + "/" + userId,
        headers: headers
      });
      console.log("🚀 ~ result:", result);
      if (result !== null && result.Items !== null) {
        thunkAPI.dispatch(setResponse(result));
        return result;
      }
    } catch (error) {
      return Promise.reject(error ? error : "Something went wrong");
    }
  }
);

export const ribbonsTransactionListSlice = createSlice({
  name: "ribbonsTransactionList",
  initialState,
  reducers: {
    setResponse: (state, action: PayloadAction<any>) => {
      state.Response = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInitialRibbonsTransactionState.pending, (state) => {
        state.apiState = "fetching";
      })
      .addCase(getInitialRibbonsTransactionState.fulfilled, (state, action) => {
        state.apiState = "idle";
      })
      .addCase(getInitialRibbonsTransactionState.rejected, (state) => {
        state.apiState = "failed";
      });
  }
});

export default ribbonsTransactionListSlice.reducer;

export const { setResponse } = ribbonsTransactionListSlice.actions;

export const getAPIStatus = (state: RootState) =>
  state?.ribbonsTransactionList?.apiState;

export const getResponse = (state: RootState) =>
  state?.ribbonsTransactionList?.Response;
